import { render, staticRenderFns } from "./avg-rate.vue?vue&type=template&id=054c8140&"
import script from "./avg-rate.vue?vue&type=script&lang=js&"
export * from "./avg-rate.vue?vue&type=script&lang=js&"
import style0 from "./avg-rate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports